import React from 'react';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, Typography } from '@mui/material';

const DialogOpenCpanel = (props) => {

    //const openDialog = props.openDialog;
    const openDialog = props.openDialog;
    const titleDialog = props.titleDialog;
    const contentDialog = props.contentDialog;
    const styleDialog = props.styleDialog;

    const handleCloseDialog = () => {
        //setOpenDialog(false);
        //navigate('/clientarea/account/', { replace: true });
        props.actionDialog(false);
    };

    return (
        <Dialog
            open={openDialog}
            onClose={handleCloseDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle variant="dialogTitle-nk" id="alert-dialog-title" color={styleDialog}>
                {titleDialog}
            </DialogTitle>
            <DialogContent>
                <Typography color={styleDialog}>{contentDialog}</Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseDialog} autoFocus variant='outlined' size="small">
                    Entendido
                </Button>
            </DialogActions>

        </Dialog>
    );
}

export default DialogOpenCpanel;